// @ts-nocheck
/* eslint-env browser */
import { canUseDOM } from 'exenv';

interface CookieOptions {
  name: string;
  value?: string | object;
  path?: string;
  domain?: string;
  expires?: Date | string;
}

interface Cookie {
  set: (options: CookieOptions) => void;
  unset: (name: string) => void;
  delete: (name: string) => void;
  get: (name: string) => string | undefined;
}

const cookie: Cookie = {
  set({ name, value = '', path = '/', domain = '', expires }) {
    if (!canUseDOM) { return; }

    let expiresStr = '';
    if (expires instanceof Date) {
      expiresStr = expires.toUTCString();
    } else if (typeof expires === 'string') {
      expiresStr = expires;
    }

    const v = typeof value === 'object' ? JSON.stringify(value) : value;

    document.cookie = [
      `${name}=${v}`,
      `path=${path}`,
      `domain=${domain}`,
      `expires=${expiresStr}`
    ].join(';');
  },

  unset(name: string) {
    cookie.set({ name, expires: new Date(0) });
  },

  delete(name: string) {
    cookie.set({ name, expires: new Date(0) });
  },

  get(name: string): string | undefined {
    const re = new RegExp(['(?:^|; )',
      name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1'),
      '=([^;]*)'
    ].join(''));

    const matches = document.cookie.match(re);

    return matches ? decodeURIComponent(matches[1]) : undefined;
  }
};

export default cookie;
